import type { MealEstimate } from "../../types";
import type { VisionProvider, VisionInput, VisionOptions } from "../types";
import { apiJson } from "../../apiFetch";

// Calls /api/estimate, a Cloudflare Pages Function that holds the Gemini key
// server-side. The Function verifies the Supabase JWT, enforces a per-user
// daily rate limit, and clamps the returned macros. Direct browser-to-Gemini
// calls have been removed so the key is never bundled into client JS.

async function estimate(
  { imageDataUrl, caption }: VisionInput,
  options?: VisionOptions
): Promise<MealEstimate> {
  options?.onProgress?.("uploading");
  // We can't truly observe "uploading" vs "analyzing" through fetch — the
  // server doesn't stream. So we transition optimistically: as soon as the
  // request is in flight, mark analyzing.
  const result = await apiJson<MealEstimate>("/api/estimate", {
    method: "POST",
    body: JSON.stringify({ imageDataUrl, caption }),
    signal: options?.signal
  });
  options?.onProgress?.("parsing");
  // Cheap tick so the UI can render the phase change before resolving.
  await new Promise((r) => setTimeout(r, 50));
  options?.onProgress?.("done");
  return result;
}

export const geminiProvider: VisionProvider = {
  name: "gemini",
  enabled: true,
  estimate
};
